import React, { useEffect, useRef } from 'react';
import { PinnedPanel } from '../../../../../../components/PinnedPanel/PinnedPanel';
import AcceptanceViewInfo from '../../controllers/AcceptanceViewInfo';
import { useSearchParamsSelector } from '../../../../shared/packages/searchParamsManager';
import { toInteger } from '../../../../shared/packages/searchParamsNormalizer';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import DownloadSummaryReport from '../../controllers/DownloadSummaryReport';
import styles from './index.module.scss';

const PinnedSideBar = ({ className }) => {
  const panelRef = useRef(null);

  const currentCompanyId = useSearchParamsSelector(selectCompanyId);

  useEffect(() => {
    if (!panelRef.current) return;

    panelRef.current.setPinned(true);
  }, [currentCompanyId]);

  return (
    <PinnedPanel
      ref={panelRef}
      className={styles.root}
      pinTooltipTitle="Открыть панель"
      unpinTooltipTitle="Закрыть панель"
      pinIcon="double-right"
      header={
        <div className={styles.header}>
          <h2 className={styles.title}>Приемки</h2>
        </div>
      }
    >
      <aside className={className}>
        <AcceptanceViewInfo renderActions={renderActions} />
      </aside>
    </PinnedPanel>
  );
};

export default PinnedSideBar;

function selectCompanyId(state) {
  return toInteger(state[searchParamKeys.company]);
}

function renderActions({ acceptanceId, houseId, className }) {
  return (
    <DownloadSummaryReport
      acceptanceId={acceptanceId}
      houseId={houseId}
      className={className}
    />
  );
}
